/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  $.count_pagination = function() {
    if ($('.js-current-count').length > 0) { return $('.js-current-count').text($(".js-countable-module").length); }
  };

  return $.count_pagination();
});
